import React, { useEffect, useState } from 'react';
import { CoreForm, fetchForm } from '@kineticdata/react';
import { useHistory, useParams } from 'react-router-dom';
import { PageTitle } from './PageTitle';

export const Form = ({ defaultKapp }) => {
  const history = useHistory();
  const { formSlug } = useParams();

  // fetch and set form
  const [form, setForm] = useState();
  useEffect(() => {
    async function fetchFormRequest() {
      let response = await fetchForm({
        kappSlug: defaultKapp,
        formSlug,
        public: true,
      });
      setForm(response.form);
    }
    fetchFormRequest();
  }, [formSlug, defaultKapp]);

  const handleCreated = response => {
    // Check if either currentPage is null (pre form consolidation) or
    // displayedPage.type is not 'confirmation' (post form-consolidation)
    // to determine that there is no confirmation page and we should redirect.
    if (
      !response.submission.currentPage ||
      (response.submission.displayedPage &&
        response.submission.displayedPage.type !== 'confirmation')
    ) {
      history.push(`/confirmation`);
    }
  };

  return (
    <div>
      {form && (
        <>
          <PageTitle title={form.name} />
          <div className="form-wrapper">
            <h1>{form.name}</h1>
            <CoreForm
              kapp={defaultKapp}
              form={formSlug}
              onCreated={handleCreated}
              public={true}
            />
          </div>
        </>
      )}
    </div>
  );
};
